import React from 'react'

import { setaDropdown } from '../../../utils/alternanciaIcones'

import Divisor from './Divisor'

export default function DropdownDispositivos(props) {
  return (
    <>
      <div
        className="drop-acoes-menu item-drop-acoes-hover"
        onClick={(e) =>
          props.dropMenuOpcoes(
            e,
            'menu-mostrar-em-dispositivos',
            'imagem-menu-mostrar-em-dispositivos'
          )
        }
      >
        <span className="drop-acoes-menu-label fonte-cor-1">
          Mostrar em dispositivos
        </span>
        <img
          id="imagem-menu-mostrar-em-dispositivos"
          className="menu-opcoes-icone-desativado nao-selecionavel"
          src={setaDropdown()}
          alt="drop"
        />
      </div>
      <Divisor />
    </>
  )
}
